import { IMAGES } from 'common/images';
import { Modal as RBModal, Row, Image } from 'react-bootstrap';
import 'components/Modal/index.scss';

export const Modal = ({ onClose, visible, children, size = "lg" }) => (
  <RBModal show={visible} contentClassName="my-modal" centered size={size} onEscapeKeyDown={onClose} onHide={onClose}>
    <Row className="justify-content-end">
      <Image src={IMAGES.Close} onClick={onClose} alt="close" className="my-modal__close" />
    </Row>
    {children}
  </RBModal>
);
